import * as React from 'react';
import { Menu } from './Menu';
import { ActionMenu } from './ActionMenu';
import { MenuDrawer } from './MenuDrawer';
import classes from './TopNav.module.scss';
import logo from '../../assets/images/logo.svg';
import classNames from 'classnames';
import { getNumberOfWorkspaces } from './helpers/Workspace';
import { useUserData } from '../../hooks/useUserData';
import { Link } from 'react-router-dom';
import { Select } from '../../components/forms/Select';
import { HamburgerMenuType, WorkspaceSwitcher } from './TopNav.controller';
import { SquareButton } from '../../components/actions/SquareButton';
import { SquareButtonIconsEnum } from '../../constants/square-button-icons';
import { useSubscriptionStatus } from 'hooks/useSubscriptionStatus';

export type TopNavViewProps = {
  workspaceSwitcher: WorkspaceSwitcher;
  hamburgerMenu: HamburgerMenuType;
  selectedWorkspaceId: string;
};

export const TopNavView = (props: TopNavViewProps): JSX.Element => {
  const userData = useUserData();
  const hasMoreWorkspaces = getNumberOfWorkspaces(userData.userData?.organizations) > 1;
  const navClasses = classNames('small-grid', classes.TopNav);
  const { isAccessBlocked } = useSubscriptionStatus();

  const logoClasses = classNames('cell', 'shrink', {
    'show-for-large': hasMoreWorkspaces,
    'show-for-tablet-portrait': !hasMoreWorkspaces
  });
  const hamburgerClasses = classNames('cell', 'shrink', {
    'hide-for-tablet-portrait': !hasMoreWorkspaces,
    'hide-for-large': hasMoreWorkspaces
  });
  const menuClasses = classNames('cell', 'shrink', {
    'show-for-large': hasMoreWorkspaces,
    'show-for-tablet-portrait': !hasMoreWorkspaces
  });

  const dropdownElem = hasMoreWorkspaces ? (
    <div className={'cell shrink show-for-large'}>
      <div className={classes.WorkspaceDropdownWrapper}>
        <Select
          items={props.workspaceSwitcher.organizations}
          inlinedLabel
          name={'selectWorkspace'}
          rules={{}}
          size={'large'}
          type={'dark'}
          action={(value, complete) => {
            complete(true);
            props.workspaceSwitcher.changeWorkspaceAction(value);
          }}
          selectedValue={props.selectedWorkspaceId ?? undefined}
          useFormInstance={props.workspaceSwitcher.useFormInstance}
        />
      </div>
    </div>
  ) : null;

  const actionMenuClasses = classNames('cell', 'shrink');

  return (
    <>
      <nav className={navClasses}>
        <div className={'grid-container'}>
          <div>
            <div className={'grid-x grid-padding-x align-justify'}>
              <div className={'cell shrink'}>
                <div className={'grid-x grid-padding-x'}>
                  <div className={hamburgerClasses}>
                    <div className={classes.MenuHamburger}>
                      <SquareButton
                        type={'white'}
                        icon={SquareButtonIconsEnum.hamburger}
                        action={() => {
                          props.hamburgerMenu.setOpenHamburgerMenu(!props.hamburgerMenu.openHamburgerMenu);
                        }}
                      />
                    </div>
                  </div>
                  <div className={logoClasses}>
                    <Link to={'/'} className={classes.Logo}>
                      <img src={logo} alt={'logo'} />
                    </Link>
                  </div>
                  {dropdownElem}
                </div>
              </div>
              {!isAccessBlocked && (
                <div className={menuClasses}>
                  <Menu />
                </div>
              )}
              <div className={actionMenuClasses}>
                <ActionMenu />
              </div>
            </div>
          </div>
        </div>
      </nav>
      {props.hamburgerMenu.openHamburgerMenu && (
        <MenuDrawer workspaceSwitcher={props.workspaceSwitcher} setOpen={props.hamburgerMenu.setOpenHamburgerMenu} />
      )}
    </>
  );
};
